export const DOCUMENT_STATUSES = {
  approved: "approved",
  pending_approval: "pending_approval",
  not_uploaded: "not_uploaded",
  not_approved: "not_approved",
};
